import React, { useState, useEffect, useRef } from 'react';
import styles from './CustomSelect.module.scss';
import dropdownicon from '../../../../assets/icons/formActions/inputs/arrowDown.svg';
import StatusContainer from '../../../Molecules/Custom/StatusContainer';
import Label from '../label/Label';
import { isEmpty } from 'lodash';

const CustomSelect = ({
  options,
  value,
  onChange,
  placeholder,
  icon,
  noborder,
  label,
  status,
  errors,
  touched,
  name,
  required,
  grey,
  style,
  iconStyle,
  dropdownStyle,
  type,
  selectedTextKey,
  CustomType = '',
  right,
}) => {
  const [selectedValue, setSelectedValue] = useState(value);
  const [selectedText, setSelectedText] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const selectRef = useRef(null);

  const handleSelect = (e, selectedValue) => {
    e.stopPropagation();
    setSelectedValue(selectedValue);
    if (!isEmpty(selectedTextKey)) {
      setSelectedText(selectedValue[selectedTextKey]);
    } else {
      setSelectedText(selectedValue?.text);
    }
    if (name) {
      onChange(name, selectedValue.value);
    } else {
      onChange(selectedValue);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedValue(value);
    const selectedOption = options?.find((option) => option?.value === value);
    if (selectedOption) {
      setSelectedText(selectedOption?.text);
    } else {
      setSelectedText('');
    }
  }, [value, options]);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  const handleContainerClick = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const filteredOptions = options?.filter((option) =>
    option?.text?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div className={styles.selectContainer} style={{ ...style }}>
      {label && (
        <div
          onClick={handleContainerClick}
          style={{ marginBottom: '5px', direction: right ? 'rtl' : '' }}
        >
          <Label text={label} required={required} right={right} />
        </div>
      )}
      <div
        ref={selectRef}
        className={`${
          noborder
            ? styles.selectInpuNoBorders
            : errors && touched
              ? styles.error
              : styles.selectInput
        } ${isOpen ? styles.open : ''}`}
        onClick={handleContainerClick}
        style={{
          border: grey ? '1px solid #0003b' : '',
          direction: right ? 'rtl' : '',
          ...dropdownStyle,
        }}
      >
        <div
          className={styles.selectedValueicont}
          onClick={handleContainerClick}
        >
          {isOpen ? (
            <input
              type='text'
              placeholder={placeholder}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={handleInputClick}
              className={styles.searchInput}
              autoFocus
            />
          ) : (
            <span
              className={`${styles.placeholder} ${
                selectedText ? styles.selectedText : ''
              }`}
              style={{ color: selectedText ? '#000' : '#8d90a5' }}
            >
              {icon && <img src={icon} alt='icon' style={{ ...iconStyle }} />}
              {selectedText ? selectedText : placeholder}
            </span>
          )}
          <img
            src={dropdownicon}
            alt='dropdown icon'
            className={styles.arrowIcon}
          />
        </div>
      </div>
      {isOpen && (
        <div className={styles.dropdown}>
          {filteredOptions && filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={option.value}
                className={
                  index % 2 === 0 ? styles.dropdownItem : styles.dropdownItemOdd
                }
                onClick={(e) => handleSelect(e, option)}
              >
                {status ? (
                  <StatusContainer status={option?.text} />
                ) : (
                  <div className={styles.dropdowncontainer}>{option?.text}</div>
                )}
              </div>
            ))
          ) : (
            <div className={styles.dropdownItem}>No options</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
